import React, { useState, cloneElement, useMemo } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { connect } from 'react-redux';

import { fetchDetails } from '../../../modals/invoiceDetails/actions/getDetails';
import { translate } from '../../../i18n/I18nProvider';

function DotsMenu({ children, clientId, data, fetchDetails, selectedAccount }) {
  const invoiceId = useMemo(() => data.invoiceNumber, [data.invoiceNumber]);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onShowDetailsClick = () => {
    fetchDetails({
      clientId,
      invoiceId,
      invoiceAccount: data.account,
      account: selectedAccount
    });
    setAnchorEl(null);
  };

  return (
    <div>
      {cloneElement(children, { onClick: handleClick })}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MenuItem onClick={onShowDetailsClick}>
          {translate('INVOICES.SHOW_DETAILS')}
        </MenuItem>
      </Menu>
    </div>
  );
}

const mapStatesToProps = ({ invoices, selectClient }) => {
  return {
    clientId: selectClient.selectedClient.id,
    selectedAccount: invoices.selectedAccount
  };
};

const mapDispatchToProps = {
  fetchDetails
};

export default connect(mapStatesToProps, mapDispatchToProps)(DotsMenu);
